import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { t } from 'i18next';
import { ModalCloseButton } from '~components/ui/ModalCloseButton';
import { MaybePromise } from '~utils/types';

interface Props {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => MaybePromise<void>;
}

/**
 * Confirms clearing a day. Deliberately not the shared `DestructiveAlert`: the
 * design has no warning icon and confirms in blue rather than red.
 */
export function ClearScheduleDayModal({ isOpen, onCancel, onConfirm }: Props) {
  return (
    <Modal isOpen={isOpen} onClose={onCancel} scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('clear')}</ModalHeader>
        <ModalCloseButton onClick={onCancel} />
        <ModalBody>
          <Text>{t('clearDayConfirmation')}</Text>
          <Text>{t('clearDayNotice')}</Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" colorScheme="blue" onClick={onCancel}>
            {t('cancel')}
          </Button>
          <Button variant="solid" colorScheme="blue" marginLeft="3" onClick={onConfirm}>
            {t('yesClearAll')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
